// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

function TbHexName(Props) {
  var lang = Props.lang;
  var nameParts = Props.nameParts;
  switch (lang) {
    case "ja" :
    case "zh" :
        break;
    default:
      
  }
  return React.createElement("g", {
              transform: "translate(44, 66)"
            }, Belt_Array.mapWithIndex(nameParts, (function (idx, part) {
                    var tmp;
                    switch (lang) {
                      case "ja" :
                      case "zh" :
                          tmp = "14px";
                          break;
                      default:
                        tmp = "15px";
                    }
                    return React.createElement("text", {
                                key: String(idx),
                                className: CssJs.merge([
                                      "pointer-events-none",
                                      CssJs.style([T.sm_([CssJs.unsafe("textShadow", "-1px 0 2px #000, 0 1px 2px #000, 1px 0 2px #000, 0 -1px 2px #000")])])
                                    ]),
                                fill: "white",
                                fontSize: tmp,
                                textAnchor: "middle",
                                y: nameParts.length < 2 ? "0" : String((((idx + 2 | 0) - nameParts.length | 0) << 4) - 3 | 0)
                              }, part);
                  })));
}

var make = TbHexName;

export {
  make ,
  
}
/* T Not a pure module */
